// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format7 } from '../../constants';

/** Caribbean Netherlands */
const BQ: PhoneNumberData = [599, 'BQ', 7, format7, /^(?:[347])/];

export default BQ;
